import React from 'react';
import { Helmet } from 'react-helmet-async';

const SeoWrapper = ({ title, description, url, type = 'website', image, schema, keywords }) => {
  const siteName = 'Kamil Priefer | IT & Software';
  const defaultDescription = 'Profesjonalne usługi programistyczne i wsparcie IT. Tworzenie aplikacji, stron www oraz kompleksowa opieka nad infrastrukturą.';
  const defaultImage = 'https://priefer.pl/logo512.png';
  const siteUrl = 'https://priefer.pl';
  const defaultKeywords = 'Informatyk Poznań, Programista React, Usługi IT Poznań, Freelancer IT, Tworzenie stron www, Wsparcie IT dla firm, Aplikacje Webowe';

  const fullTitle = `${title} | ${siteName}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      <link rel="canonical" href={`${siteUrl}${url}`} />
      <meta name="robots" content="index, follow" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={`${siteUrl}${url}`} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:image" content={image || defaultImage} />
      <meta property="og:site_name" content={siteName} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={`${siteUrl}${url}`} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description || defaultDescription} />
      <meta property="twitter:image" content={image || defaultImage} />

      {/* Structured Data (JSON-LD) */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export default SeoWrapper;
